import {
  type BrandVariants,
  createDarkTheme,
  type Theme,
} from '@fluentui/react-components';

/**
 * OPUS NOVA brand ramp — replica los tokens --opus-brand-{10..100}
 * del design system (DESIGNSTUFF/opus-nova-design-system.html).
 *
 * Fluent UI v9 espera 16 stops; mapeamos los 10 que tenemos en el DS
 * a la escala 10-160 de Fluent (interpolando los faltantes).
 */
const opusBrand: BrandVariants = {
  10:  '#040a14',
  20:  '#0a1626',
  30:  '#0f2745',
  40:  '#143869',
  50:  '#1c4f93',
  60:  '#2f78e6',
  70:  '#4189f0', // primary / accent
  80:  '#5e9cf3',
  90:  '#84b4f6',
  100: '#a8caf9',
  110: '#bcd6fb',
  120: '#cfe1fc',
  130: '#ddeafd',
  140: '#ebf3fe',
  150: '#f4f8fe',
  160: '#fafcff',
};

/**
 * Radios de Fluent alineados al hub del cliente (los comparten los dos temas): botones e
 * inputs 8px (= --radius-control), menús y popovers 12px, diálogos 16px (= --radius-card).
 */
export const RADIOS_OPUS = {
  borderRadiusMedium: '8px',
  borderRadiusLarge: '12px',
  borderRadiusXLarge: '16px',
} as const;

/**
 * Tema dark de Fluent v9 con la marca OPUS NOVA.
 * Se aplica vía <FluentProvider theme={opusNovaDarkTheme}>.
 */
export const opusNovaDarkTheme: Theme = {
  ...createDarkTheme(opusBrand),

  // Overrides de tokens core para alinear con el DS (paleta v2 del mockup)
  colorNeutralBackground1: '#111726',   // panel
  colorNeutralBackground2: '#151c2c',   // panel-2
  colorNeutralBackground3: '#1a2233',   // panel-hover
  colorNeutralBackground4: '#222b3c',
  colorNeutralBackground1Hover: '#1a2233',
  colorNeutralBackground1Pressed: '#222b3c',

  colorNeutralForeground1: '#e8edf4',
  colorNeutralForeground2: '#a7b1c2',
  colorNeutralForeground3: '#6c7789',
  colorNeutralForeground4: '#545f72',

  colorNeutralStroke1: '#222b3c',
  colorNeutralStroke2: '#1a2233',
  colorNeutralStrokeAccessible: '#2d3850',

  // Acento del mockup (#4189f0 / hover #2f78e6)
  colorBrandBackground: '#4189f0',
  colorBrandBackgroundHover: '#2f78e6',
  colorBrandBackgroundPressed: '#2f78e6',

  ...RADIOS_OPUS,

  // Tipografía
  fontFamilyBase: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontFamilyMonospace: "'JetBrains Mono', 'SF Mono', Consolas, monospace",
};

/** Re-export del ramp por si alguien quiere construir variantes propias. */
export { opusBrand };
